var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field-list" }, [
    !_vm.fields.length
      ? _c("div", { staticClass: "field-list__empty" }, [
          _vm._v(
            " Aún no hay campos. Selecciona un tipo y haz click sobre el PDF. "
          )
        ])
      : _c(
          "ul",
          { staticClass: "field-list__items" },
          _vm._l(_vm.fields, function(field) {
            return _c(
              "li",
              {
                key: field.id,
                staticClass: "field-list__item",
                class: { "is-selected": field.id === _vm.selectedId },
                on: {
                  click: function($event) {
                    return _vm.$emit("select", field.id)
                  }
                }
              },
              [
                _c("div", { staticClass: "field-list__row" }, [
                  _c(
                    "span",
                    {
                      staticClass: "field-list__badge",
                      class: "badge--" + field.type.toLowerCase()
                    },
                    [_vm._v(" " + _vm._s(_vm.typeLabel(field.type)) + " ")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "field-list__name",
                      attrs: { title: field.name }
                    },
                    [_vm._v(_vm._s(field.label))]
                  ),
                  _c("span", { staticClass: "field-list__page" }, [
                    _vm._v("pág. " + _vm._s(field.page))
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "field-list__del",
                      attrs: { type: "button", title: "Eliminar campo" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.$emit("delete", field.id)
                        }
                      }
                    },
                    [_vm._v(" × ")]
                  )
                ]),
                field.id === _vm.selectedId
                  ? _c(
                      "div",
                      {
                        staticClass: "field-list__config",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c("label", { staticClass: "field-list__cfg-label" }, [
                          _vm._v("Etiqueta")
                        ]),
                        _c("input", {
                          staticClass: "field-list__cfg-input",
                          attrs: { type: "text" },
                          domProps: { value: field.label },
                          on: {
                            input: function($event) {
                              return _vm.updateField(
                                field,
                                "label",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c(
                          "label",
                          {
                            staticClass:
                              "field-list__cfg-label field-list__cfg-label--help"
                          },
                          [
                            _vm._v(" Clave de dato (opcional) "),
                            _c("feather-icon", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.right",
                                  value: _vm.linkKeyTooltip,
                                  expression: "linkKeyTooltip",
                                  modifiers: { hover: true, right: true }
                                }
                              ],
                              staticClass: "field-list__cfg-help-icon",
                              attrs: { icon: "HelpCircleIcon", size: "13" }
                            })
                          ],
                          1
                        ),
                        _c("input", {
                          staticClass: "field-list__cfg-input",
                          attrs: { type: "text", placeholder: "ej: rut" },
                          domProps: { value: field.linkKey },
                          on: {
                            input: function($event) {
                              return _vm.updateField(
                                field,
                                "linkKey",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm.isDate(field)
                          ? [
                              _c(
                                "label",
                                { staticClass: "field-list__cfg-label" },
                                [_vm._v("Formato de fecha")]
                              ),
                              _c(
                                "select",
                                {
                                  staticClass: "field-list__cfg-input",
                                  domProps: {
                                    value:
                                      field.dateFormat || _vm.defaultDateFormat
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.updateField(
                                        field,
                                        "dateFormat",
                                        $event.target.value
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.dateFormats, function(opt) {
                                  return _c(
                                    "option",
                                    {
                                      key: opt.value,
                                      domProps: { value: opt.value }
                                    },
                                    [_vm._v(" " + _vm._s(opt.label) + " ")]
                                  )
                                }),
                                0
                              )
                            ]
                          : _vm._e(),
                        _vm.isSelect(field)
                          ? [
                              _c(
                                "label",
                                { staticClass: "field-list__cfg-label" },
                                [_vm._v("Opciones de la lista")]
                              ),
                              _vm._m(0, true),
                              _vm._l(_vm.optionsOf(field), function(opt, i) {
                                return _c(
                                  "div",
                                  {
                                    key: i,
                                    staticClass: "field-list__opt-row"
                                  },
                                  [
                                    _c("input", {
                                      staticClass:
                                        "field-list__cfg-input field-list__opt-input",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Opción " + (i + 1)
                                      },
                                      domProps: { value: opt.label },
                                      on: {
                                        input: function($event) {
                                          return _vm.updateOption(
                                            field,
                                            i,
                                            "label",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _c("input", {
                                      staticClass:
                                        "field-list__cfg-input field-list__opt-input",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Valor " + (i + 1)
                                      },
                                      domProps: { value: opt.value },
                                      on: {
                                        input: function($event) {
                                          return _vm.updateOption(
                                            field,
                                            i,
                                            "value",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "field-list__opt-del",
                                        attrs: {
                                          type: "button",
                                          title: "Quitar opción"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeOption(field, i)
                                          }
                                        }
                                      },
                                      [_vm._v(" × ")]
                                    )
                                  ]
                                )
                              }),
                              _c(
                                "button",
                                {
                                  staticClass: "field-list__opt-add",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addOption(field)
                                    }
                                  }
                                },
                                [_vm._v(" + Agregar opción ")]
                              )
                            ]
                          : _vm._e(),
                        !_vm.isCheckbox(field)
                          ? [
                              _c(
                                "label",
                                { staticClass: "field-list__cfg-label" },
                                [_vm._v("Texto de ayuda (placeholder)")]
                              ),
                              _c("input", {
                                staticClass: "field-list__cfg-input",
                                attrs: {
                                  type: "text",
                                  placeholder: field.label
                                },
                                domProps: { value: field.placeholder },
                                on: {
                                  input: function($event) {
                                    return _vm.updateField(
                                      field,
                                      "placeholder",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _c(
                                "label",
                                { staticClass: "field-list__cfg-label" },
                                [_vm._v("Valor por defecto")]
                              ),
                              _c("input", {
                                staticClass: "field-list__cfg-input",
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    field.defaultValue == null
                                      ? ""
                                      : field.defaultValue
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.updateField(
                                      field,
                                      "defaultValue",
                                      $event.target.value || null
                                    )
                                  }
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "field-list__cfg-grid" },
                                [
                                  _c("div", [
                                    _c(
                                      "label",
                                      { staticClass: "field-list__cfg-label" },
                                      [_vm._v("Tamaño fuente")]
                                    ),
                                    _c("input", {
                                      staticClass: "field-list__cfg-input",
                                      attrs: {
                                        type: "number",
                                        min: "6",
                                        max: "72"
                                      },
                                      domProps: {
                                        value: _vm.styleOf(field).fontSize
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.updateStyle(
                                            field,
                                            "fontSize",
                                            _vm.toSize($event.target.value)
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _c("div", [
                                    _c(
                                      "label",
                                      { staticClass: "field-list__cfg-label" },
                                      [_vm._v("Alineación")]
                                    ),
                                    _c(
                                      "select",
                                      {
                                        staticClass: "field-list__cfg-input",
                                        domProps: {
                                          value: _vm.styleOf(field).alignment
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.updateStyle(
                                              field,
                                              "alignment",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          { attrs: { value: "left" } },
                                          [_vm._v("Izquierda")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "center" } },
                                          [_vm._v("Centro")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "right" } },
                                          [_vm._v("Derecha")]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          : _vm._e(),
                        _c("label", { staticClass: "field-list__cfg-check" }, [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: { checked: field.required },
                            on: {
                              change: function($event) {
                                return _vm.updateField(
                                  field,
                                  "required",
                                  $event.target.checked
                                )
                              }
                            }
                          }),
                          _vm._v(" Requerido ")
                        ])
                      ],
                      2
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-list__opt-head" }, [
      _c("span", [_vm._v("Etiqueta (se muestra)")]),
      _c("span", [_vm._v("Valor (se estampa)")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }